$(document).ready(function() {

	$(document).on('click', '.js-vi-size', function() {
		$('.js-vi-size').removeClass('active');
		$(this).addClass('active');
	});

	$(document).on('click', '.js-vi-color', function() {
		$('.js-vi-color').removeClass('active');
		$(this).addClass('active');
	});

	$(document).on('click', '.js-vi-length', function() {
		$('.js-vi-length').removeClass('active');
		$(this).addClass('active');
	});

	$(document).on('click', '.js-vi-images', function() {
		$('.js-vi-images').removeClass('active');
		$(this).addClass('active');
	});
});


// WEBPACK FOOTER //
// ./src/js/visually-impaired/click.js